// <s-bundle-add>: adds every item in its bundle form to the cart in one step.
// Uses Shopify Standard Actions (the same path as the product form, so the cart drawer opens and
// counts refresh). If that's unavailable or fails, it falls back to the Ajax cart API and goes to the cart.
// Markup: a <form> with hidden inputs items[N][id] / items[N][quantity] and one submit button.
class SBundleAdd extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (this.getAttribute('aria-busy') === 'true') return;
      this.add();
    });
  }

  lines() {
    const data = new FormData(this.form);
    const lines = [];
    for (let i = 0; data.has(`items[${i}][id]`); i += 1) {
      const id = String(data.get(`items[${i}][id]`) || '').trim();
      const quantity = parseInt(String(data.get(`items[${i}][quantity]`) || '1'), 10) || 1;
      if (id) lines.push({ id, quantity });
    }
    return lines;
  }

  setBusy(busy) {
    if (busy) this.setAttribute('aria-busy', 'true');
    else this.removeAttribute('aria-busy');
    const button = this.form?.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = busy;
      button.classList.toggle('opacity-60', busy);
    }
  }

  async add() {
    const lines = this.lines();
    if (!lines.length) return;
    this.setBusy(true);
    try {
      const actions = window.Shopify?.actions;
      if (actions?.updateCart) {
        try {
          const result = await actions.updateCart(
            { lines: lines.map((line) => ({ merchandiseId: line.id, quantity: line.quantity })) },
            { event: { context: 'product' } }
          );
          if (!result?.userErrors?.length) {
            this.closest('dialog')?.close();
            await actions.openCart?.();
            return;
          }
        } catch {
          // Fall through to the Ajax cart below.
        }
      }
      await this.ajaxAdd(lines);
    } finally {
      this.setBusy(false);
    }
  }

  async ajaxAdd(lines) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines }),
    });
    if (response.ok) {
      window.location.href = `${root}cart`;
    } else {
      this.form.submit(); // last resort: the plain form post
    }
  }
}

if (!customElements.get('s-bundle-add')) customElements.define('s-bundle-add', SBundleAdd);
